import React, { useState, useEffect } from 'react';
import { Star, Quote } from 'lucide-react';
import { SEOHead } from '../components/site/SEOHead';
import api, { getFileUrl } from '../lib/api';

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [version, setVersion] = useState('v1');
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    api.get('/settings/references')
      .then(r => {
        setVersion(r.data?.version === 'v2' ? 'v2' : 'v1');
        setLogos(Array.isArray(r.data?.logos) ? r.data.logos : []);
      })
      .catch(() => { setVersion('v1'); });
    api.get('/testimonials?active_only=true')
      .then(r => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="testimonials-page">
      <SEOHead title="Referanslar" />
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">Referanslar</h1>
          <p className="text-gray-300 mt-2">{version === 'v2' ? 'Birlikte çalıştığımız kurumlar' : 'Müşterilerimizin görüşleri'}</p>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          {loading ? (
            <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>
          ) : version === 'v2' ? (
            logos.length === 0 ? (
              <div className="text-center py-20 text-muted-foreground">Henüz logo eklenmemiş</div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="reference-logo-grid">
                {logos.map((logo, i) => {
                  const card = (
                    <div className="h-28 md:h-32 w-full rounded-2xl bg-white border border-border shadow-[var(--shadow-elev-1)] flex items-center justify-center p-6 transition-transform duration-200 hover:-translate-y-0.5">
                      <img
                        src={getFileUrl(logo.image_path)}
                        alt={logo.name || 'Referans'}
                        loading="lazy"
                        className="max-h-full max-w-full w-auto h-auto object-contain"
                      />
                    </div>
                  );
                  return logo.link ? (
                    <a key={i} href={logo.link} target="_blank" rel="noopener noreferrer" title={logo.name || ''} data-testid={`reference-logo-${i}`}>
                      {card}
                    </a>
                  ) : (
                    <div key={i} title={logo.name || ''} data-testid={`reference-logo-${i}`}>{card}</div>
                  );
                })}
              </div>
            )
          ) : items.length === 0 ? (
            <div className="text-center py-20 text-muted-foreground">Henüz referans eklenmemiş</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map(t => (
                <div key={t.id} className="p-6 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)] flex flex-col">
                  <div className="mb-4">
                    <Quote className="w-8 h-8 text-[hsl(var(--gold)/0.3)]" />
                  </div>
                  <p className="text-sm leading-relaxed text-muted-foreground flex-1 mb-4">{t.content}</p>
                  <div className="flex gap-0.5 mb-4">
                    {[1,2,3,4,5].map(i => (
                      <Star key={i} className={`w-4 h-4 ${i <= (parseInt(t.rating) || 5) ? 'text-[hsl(var(--gold))] fill-[hsl(var(--gold))]' : 'text-gray-300'}`} />
                    ))}
                  </div>
                  <div className="flex items-center gap-3 pt-4 border-t border-border">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary shrink-0">
                      {t.image_path ? (
                        <img src={getFileUrl(t.image_path)} alt={t.name} className="w-full h-full object-cover" />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-sm font-bold text-muted-foreground">{t.name?.[0]}</div>
                      )}
                    </div>
                    <div>
                      <div className="font-medium text-sm">{t.name}</div>
                      <div className="text-xs text-muted-foreground">
                        {t.title}{t.title && t.company ? ' - ' : ''}{t.company}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
